module.exports = __webpack_public_path__ + "static/media/buddy-match.bdb71fea.png";